<template>
  <div class="button-edit py-2 px-4">
    <!-- <v-text-field hide-details placeholder="Video URL" @input="updateContent()" v-model="btnContent" label="Video URL"></v-text-field> -->
    <rich-text-input :placeholder="$t('video_url')" :content.sync="form.content" mode="url" :json.sync="editorContentJson" :label="$t('video_url')"></rich-text-input>
  </div>
</template>

<script>

import RichTextInput from '@/components/utils/RichTextInput'

export default {
  name: 'VideoEdit',
  props: ['content'],
  components: {
    RichTextInput
  },
  data () {
    return {
      editorContentJson: {},
      form: {
        content: ''
      }
    }
  },
  created () {
    this.form.content = this.content
    if (typeof this.form.content !== 'string') {
      this.form.content = ''
    }
  },
  methods: {
    // updateContent () {
    //   if (this.btnContent.indexOf('/watch?v=') > -1) {
    //     let videoId = this.btnContent.split('/watch?v=')[1]
    //     this.btnContent = 'https://www.youtube.com/embed/' + videoId
    //   }
    //   this.$emit('update:content', this.btnContent)
    // }
  }
}
</script>

<style lang="sass">

</style>
